import { ProvinceDetailResponseModel } from "api/repositories/address/province/model/detail/ProvinceDetailResponseModel"
import { UserManagementResponseModel } from "api/repositories/userManagement/model/UserManagementResponse"

export interface AppProfileModel {
  createdAt?: string,
  updatedAt?: string,
  id?: string,
  name?: string,
  code?: string,
  providerCode?: number,
  providerPreviewCode?: string
  type?: number,
  status?: number,
  expriedSignDate?: string,
  expriedAt?: string,
  isVerified?: boolean,
  organization?: OrganizationModel,
  template?: string,
  participants?: ParticipantsModel[],
  userContracts?: ParticipantsModel[],
  file?: AssetsModel,
  reason?: string,
  approvedBy?: UserManagementResponseModel
}

export interface AssetsModel {
  id?: string,
  code?: string,
  classify?: AssetsClassify,
  url?: string,
  order?: number,
  title?: string
}

export enum AssetsClassify {
  default = 0,
  avatar = 1,
  idCard = 2,
  contract = 3,
  businessCerts = 4
}

export interface ParticipantsModel {
  createdAt?: string,
  updatedAt?: string,
  id?: string,
  code?: string,
  recipentCode?: number,
  phoneNumber?: string,
  type?: number,// 0: Sigle customer, 1: Organization
  status?: number, // 0: Init, 1: Processing, 2: Signed, 3: Expried
  user?: string,
  contract?: string,
  files?: AssetsModel[],
  taxCode?: string,
  bankAccount?: string,
  bankName?: string,
  bankInfo?: UserBankInfoModel,
  fullName?: string
  email?: string,
  idNumber?: string,
  idIssueDate?: string,
  idIssuePlace?: string,
  addressDetails?: UserAddressModel
}

export interface OrganizationModel {
  name?: string,
  address?: string,
  email?: string,
  taxCode?: string,
  bankAccount?: string,
  bankName?: string,
  bankInfo?: UserBankInfoModel,
  representativeName?: string,
  representativeRole?: string,
  businessCerts?: AssetsModel[]
}

export interface UserAddressModel {
  district?: ProvinceDetailResponseModel,
  province?: ProvinceDetailResponseModel,
  ward?: ProvinceDetailResponseModel,
  full?: string,
}

export interface UserBankInfoModel {
  id?: number,
  name?: string,
  code?: string,
  bin?: string,
  shortName?: string,
  logo?: string,
  transferSupported?: number,
  lookupSupported?: number,
  short_name?: string,
  support?: number,
  isTransfer?: number,
  swift_code?: string
}
